export default {
  agent: null,
  agentSelected: null,
  isAgentAuthenticated: false,
  agents: null,
  allAgents: null,
  allAgentsMap: null,
  agentRoles: {
    advisor: { id: "advisor", name: "Asesor" },
    supervisor: { id: "supervisor", name: "Supervisor" },
    admin: { id: "admin", name: "Administrador" },
    super_admin: { id: "super_admin", name: "Super Administrador" },
    entrepreneur: { id: "entrepreneur", name: "Emprendedor" },
    advisor_level1: { id: "advisor_level1", name: "Cajero" },
    advisor_level2: { id: "advisor_level2", name: "Vendedor" },
  },
  showAgentDetailDrawer: null,
  agentId: null,
  agentIntegrations: null,
  menu: [],
  menuBase: [
    {
      icon: "fas fa-ticket-alt",
      title: "Oportunidades",
      path: "/opportunities",
      showOnBottomBar: true,
      items: [],
    },
    {
      icon: "fas fa-users",
      title: "Contactos",
      path: "/contacts",
      showOnBottomBar: true,
      items: [],
    },
    {
      icon: "far fa-calendar-alt",
      title: "Eventos",
      path: "/events",
      showOnBottomBar: true,
      items: [],
    },
  ],
  menuEvents: {
    icon: "far fa-calendar-alt",
    title: "Eventos",
    path: "/events",
    showOnBottomBar: true,
    items: [],
  },
  menuTickets: {
    icon: "fas fa-ticket-alt",
    title: "Oportunidades",
    path: "/opportunities",
    showOnBottomBar: true,
    items: [],
  },
  menuBusiness: {
    icon: "fas fa-briefcase",
    title: "Negocio",
    path: "/business",
    items: [
      {
        icon: "fas fa-ad",
        title: "Información",
        path: "/business/information",
      },
      {
        icon: "fas fa-ad",
        title: "Tiendas",
        path: "/business/stores",
      },
      {
        icon: "fas fa-files",
        title: "Archivos",
        path: "/business/files",
      },
      {
        icon: "fas fa-files",
        title: "FAQs",
        path: "/business/faqs",
      },
      {
        icon: "fas fa-files",
        title: "Recaudos 360pay",
        path: "/business/360pay",
      },
    ],
  },
  menuOrder: {
    icon: "fas fa-receipt",
    title: "Ventas",
    path: "/orders",
    items: [],
  },
  menuStatistics: {
    icon: "fas fa-chart-line",
    title: "Métricas",
    path: "/statistics",
    items: [],
  },
  menuSegments: {
    icon: "fas fa-cubes",
    title: "Segmentos",
    path: "/segments",
    items: [],
  },
  menuCampaigns: {
    icon: "fas fa-ad",
    title: "Campañas",
    path: "/campaigns",
    items: [],
  },
  menuCatalog: {
    icon: "fas fa-store",
    title: "Catálogo",
    path: "/catalog",
    items: [
      {
        icon: "fas fa-store",
        title: "Productos",
        path: "/catalog/products",
      },
      {
        icon: "fas fa-ad",
        title: "Categorías",
        path: "/catalog/categories",
      },
      {
        icon: "fas fa-ad",
        title: "Colecciones",
        path: "/catalog/collections",
      },
      {
        icon: "fas fa-ad",
        title: "Atributos",
        path: "/catalog/attributes",
      },
      {
        icon: "fas fa-ad",
        title: "Zonas",
        path: "/catalog/zones",
      },
      {
        icon: "fas fa-ad",
        title: "Métodos de pago",
        path: "/catalog/payments",
      },
    ],
  },
  menuChannels: {
    icon: "fas fa-bullhorn",
    title: "Canales",
    path: "/channels",
    items: [
      {
        icon: "fas fa-ad",
        title: "Comercio electrónico",
        path: "/channels/ecommerce",
      },
      {
        icon: "fas fa-ad",
        title: "Landing page",
        path: "/channels/landing-page",
      },
      {
        icon: "fas fa-link",
        title: "Páginas de enlace",
        path: "/channels/link-pages",
      },
      {
        icon: "fas fa-ad",
        title: "Formularios",
        path: "/channels/embed-forms",
      },
      {
        icon: "fas fa-ad",
        title: "Página agente",
        path: "/channels/custom-forms",
      },
      {
        icon: "fas fa-ad",
        title: "WhatsApp",
        // path: "/channels/whatsapp/apps",
        items: [
          {
            icon: "fas fa-ad",
            title: "Cuentas",
            path: "/channels/whatsapp/apps",
          },
          {
            icon: "fas fa-ad",
            title: "Plantillas de mensajes",
            path: "/channels/whatsapp/message-templates",
          },
          {
            icon: "fas fa-ad",
            title: "Respuestas rápidas",
            path: "/channels/whatsapp/quick-replies",
          },
          {
            icon: "fas fa-ad",
            title: "Acciones automáticas",
            path: "/channels/whatsapp/actions",
          },
          {
            icon: "fas fa-ad",
            title: "Asistente virtual",
            path: "/channels/whatsapp/assistant",
          },
          {
            icon: "fas fa-ad",
            title: "Configuraciones",
            path: "/channels/whatsapp/settings",
          },
        ],
      },
      {
        icon: "fas fa-ad",
        title: "Bandeja de correo",
        path: "/channels/mail",
      },
    ],
  },
  menuChannelOnlyWhatsApp: {
    icon: "fas fa-bullhorn",
    title: "Canales",
    path: "/channels",
    items: [
      {
        icon: "fas fa-ad",
        title: "WhatsApp",
        path: "/channels/whatsapp",
      },
    ],
  },
  menuAgents: {
    icon: "fas fa-people-carry",
    title: "Colaboradores",
    path: "/agents",
    items: [],
  },
  menuWarehouse: {
    icon: "fas fa-warehouse",
    title: "Almacén",
    path: "/warehouse",
    items: [
      {
        icon: "fas fa-ad",
        title: "Almacenes",
        path: "/warehouse/warehouses",
      },
      // {
      //   icon: "fas fa-ad",
      //   title: "Proveedores",
      //   path: "/warehouse/providers",
      // },
      {
        icon: "fas fa-ad",
        title: "Stock",
        path: "/warehouse/stock",
      },
      {
        icon: "fas fa-ad",
        title: "Movimientos",
        path: "/warehouse/logs",
      },
      // {
      //   icon: "fas fa-ad",
      //   title: "Recetas",
      //   path: "/warehouse/flavors",
      // },
    ],
  },
};
